const Roles = {
  admin: "admin",
  user: "user",
  division_admin: "division_admin",
  translator: "translator",
};

export default Roles;
